import type { ReactNode } from 'react';

export const symbol_replace_video: ReactNode = (
	<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 -960 960 960">
		<path
			fill="currentColor"
			d="M260-140h360v-360H260v360Zm0 0v-360 360Zm0 60q-24.75 0-42.37-17.63Q200-115.25 200-140v-360q0-24.75 17.63-42.38Q235.25-560 260-560h360q24.75 0 42.38 17.62Q680-524.75 680-500v140l94-94q7-7 16.5-3.46T800-444v248q0 9.92-9.5 13.46Q781-179 774-186l-94-94v140q0 24.75-17.62 42.37Q644.75-80 620-80H260Zm550-540H640q-12.75 0-21.37-8.68-8.63-8.67-8.63-21.5 0-12.82 8.63-21.32 8.62-8.5 21.37-8.5h94q-42-66-109-103t-145-37q-90 0-164.5 46.5T204-648q-7 14-18 18t-22-1q-11-5-16-15.5t0-21.5q42-97 132.5-154.5T480-880q91 0 170.5 42.5T780-719v-101q0-12.75 8.68-21.38 8.67-8.62 21.5-8.62 12.82 0 21.32 8.62 8.5 8.63 8.5 21.38v170q0 12.75-8.62 21.37Q822.75-620 810-620Z"
		/>
	</svg>
);
